var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3471 7.92247L9.64643 11.2694C9.63744 11.2776 9.62889 11.2861 9.62079 11.2952C9.49164 11.439 9.50352 11.6603 9.64734 11.7894L13.3046 15.0739C13.6286 15.3648 13.6559 15.864 13.3658 16.1888C13.0756 16.5136 12.5777 16.5411 12.2538 16.2502L7.65497 12.1201C7.30635 11.8071 7.30539 11.26 7.65292 10.9457L12.2922 6.74989C12.6152 6.45781 13.1131 6.48352 13.4044 6.80732C13.6957 7.13112 13.6701 7.63039 13.3471 7.92247Z",
    fill: "#1C1F7F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.25,
    stroke: "#26298D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.ed326f9e8e73b53f43a1e7024e597940.svg";
export { ForwardRef as ReactComponent };